export const DEFAULT_ENTITY_STATE = {
  status: "idle",
  error: null,
  data: [],
};

export const persistedTables_initialState = {
  exp_grid_personal: {
    columns: {
      columnVisibilityModel: {
        placeName: false,
        groupName: false,
        branchName: false,
        projectName: false,
        travelName: false,
        paymentName: false,
        isMatched: false,
        from: false,
        to: false,
        distance: false,
        formattedRate: false,
        createdAt: false,
        discount: false,
      },
    },
    pinnedColumns: {
      right: ["totalAmount"],
    },
  },
  exp_grid_approver: {
    columns: {
      columnVisibilityModel: {
        placeName: false,
        groupName: false,
        branchName: false,
        projectName: false,
        paymentName: false,
        travelName: false,
        isMatched: false,
        from: false,
        to: false,
        distance: false,
        formattedRate: false,
        sentAt: false,
        kml: false,
        fuelType: false,
        vehicle: false,
        liters: false,
        pricePerLiter: false,
        odometer: false,
        city: false,
        state: false,
        country: false,
        destination: false,
        company: false,
        plant: false,
        branchCode: false,
        costcenter: false,
        creditAcct: false,
        debitAcct: false,
        dailyRate: false,
        dailyNumber: false,
        discount: false,
      },
    },
    pinnedColumns: {
      right: ["totalAmount"],
    },
  },
  exp_grid_financial: {
    columns: {
      columnVisibilityModel: {
        placeName: false,
        groupName: false,
        branchName: false,
        projectName: false,
        travelName: false,
        paymentName: false,
        isMatched: false,
        from: false,
        to: false,
        distance: false,
        formattedRate: false,
        sapDocument: false,
        sentAt: false,
        rejectedAt: false,
        approvedAt: false,
        finishedAt: false,
        createdAt: false,
        kml: false,
        fuelType: false,
        vehicle: false,
        liters: false,
        pricePerLiter: false,
        odometer: false,
        city: false,
        state: false,
        country: false,
        destination: false,
        company: false,
        plant: false,
        branchCode: false,
        costcenter: false,
        creditAcct: false,
        debitAcct: false,
        dailyRate: false,
        dailyNumber: false,
        discount: false,
      },
    },
    pinnedColumns: {
      right: ["totalAmount"],
    },
  },
  exp_grid_director: {
    columns: {
      columnVisibilityModel: {
        placeName: false,
        branchName: false,
        groupName: true,
        travelName: false,
        projectName: false,
        paymentName: false,
        isMatched: false,
        from: false,
        to: false,
        distance: false,
        formattedRate: false,
        sapDocument: false,
        sentAt: false,
        rejectedAt: false,
        approvedAt: false,
        createdAt: false,
        finishedAt: false,
        kml: false,
        fuelType: false,
        vehicle: false,
        liters: false,
        pricePerLiter: false,
        odometer: false,
        city: false,
        state: false,
        country: false,
        destination: false,
        company: false,
        plant: false,
        branchCode: false,
        costcenter: false,
        creditAcct: false,
        debitAcct: false,
        dailyRate: false,
        dailyNumber: false,
      },
    },
    pinnedColumns: {
      right: ["totalAmount"],
    },
  },

  transactions_dataGridState_financial: {
    columns: {
      columnVisibilityModel: {
        mccText: false,
        localName: false,
      },
    },
    pinnedColumns: {
      right: ["amount", "currency"],
    },
  },

  adv_grid_personal: {
    pinnedColumns: {
      right: ["usageAmount", "amount"],
    },
  },
  adv_grid_approver: {
    pinnedColumns: {
      right: ["usageAmount", "amount"],
    },
  },
  adv_grid_financial: {
    columns: {
      columnVisibilityModel: {
        sapDocument: false,
      },
    },
    pinnedColumns: {
      right: ["usageAmount", "amount"],
    },
  },

  travel_grid_personal: {
    pinnedColumns: {
      right: ["totalAMount"],
    },
    columns: {
      columnVisibilityModel: {
        from: false,
        startDate: false,
        endDate: false,
      },
    },
  },
  travel_grid_approver: {
    pinnedColumns: {
      right: ["totalAMount"],
    },
    columns: {
      columnVisibilityModel: {
        from: false,
        startDate: false,
        endDate: false,
      },
    },
  },
  travel_grid_financial: {
    pinnedColumns: {
      right: ["totalAMount"],
    },
    columns: {
      columnVisibilityModel: {
        from: false,
        startDate: false,
        endDate: false,
      },
    },
  },
};

export const formatTableColumnVisibilityMigration = (
  persistedTablesState = {},
  tableKey = "",
  colmuns = {}
) => {
  return {
    ...(persistedTablesState || {}),
    [`${tableKey}_personal`]: {
      ...persistedTablesState[`${tableKey}_personal`],
      rowGrouping: {
        model: [],
      },
      columns: {
        ...persistedTablesState[`${tableKey}_personal`].columns,
        columnVisibilityModel: {
          ...persistedTablesState[`${tableKey}_personal`].columns
            .columnVisibilityModel,
          ...colmuns,
        },
      },
    },
    [`${tableKey}_approver`]: {
      ...persistedTablesState[`${tableKey}_approver`],
      rowGrouping: {
        model: [],
      },
      columns: {
        ...persistedTablesState[`${tableKey}_approver`].columns,
        columnVisibilityModel: {
          ...persistedTablesState[`${tableKey}_approver`].columns
            .columnVisibilityModel,
          ...colmuns,
        },
      },
    },
    [`${tableKey}_financial`]: {
      ...persistedTablesState[`${tableKey}_financial`],
      rowGrouping: {
        model: [],
      },
      columns: {
        ...persistedTablesState[`${tableKey}_financial`].columns,
        columnVisibilityModel: {
          ...persistedTablesState[`${tableKey}_financial`].columns
            .columnVisibilityModel,
          ...colmuns,
        },
      },
    },
  };
};
